module.exports = "#loginStuff{\r\n    text-align: 180%;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/navbar/navbar.component.css
// module id = ./src/app/navbar/navbar.component.css
// module chunks = main